module.exports = __webpack_public_path__ + "static/media/gmail-icon.0a8207e2.svg";